import { flushSync } from "react-dom";
import { createRoot } from "react-dom/client";

export function jsxToNode(children: React.ReactNode) {
  const content = document.createElement("div");
  const markerRoot = createRoot(content);
  flushSync(() => {
    markerRoot.render(children);
  });
  return content;
}
